import {
    calendarDateSchema,
    childSexSchema,
    entityIdSchema,
    personNameSchema,
    utcInstantSchema,
} from '@baby-tracker/validation';
import { z } from 'zod';

import { successEnvelope } from './envelope.js';
import { API_BASE_PATH } from './routes.js';
import { familyPath } from './families.js';

export function childrenPath(familyId: string): string {
    return `${familyPath(familyId)}/children`;
}

export function childPath(childId: string): string {
    return `${API_BASE_PATH}/children/${childId}`;
}

export const childSchema = z.object({
    id: entityIdSchema,
    familyId: entityIdSchema,
    name: personNameSchema,
    dateOfBirth: calendarDateSchema,
    adjustedDateOfBirth: calendarDateSchema.nullable(),
    sex: childSexSchema,
    archivedAt: utcInstantSchema.nullable(),
    createdAt: utcInstantSchema,
    updatedAt: utcInstantSchema,
});

export type Child = z.infer<typeof childSchema>;

export const createChildInputSchema = z.object({
    name: personNameSchema,
    dateOfBirth: calendarDateSchema,
    adjustedDateOfBirth: calendarDateSchema.nullable().optional(),
    sex: childSexSchema.optional(),
});

export type CreateChildInput = z.infer<typeof createChildInputSchema>;

export const updateChildInputSchema = z
    .object({
        name: personNameSchema.optional(),
        dateOfBirth: calendarDateSchema.optional(),
        adjustedDateOfBirth: calendarDateSchema.nullable().optional(),
        sex: childSexSchema.optional(),
    })
    .refine((value) => Object.values(value).some((item) => item !== undefined), {
        message: 'At least one field is required',
    });

export type UpdateChildInput = z.infer<typeof updateChildInputSchema>;

export const childListSchema = z.array(childSchema);

export const childResponseSchema = successEnvelope(childSchema);
export const childListResponseSchema = successEnvelope(childListSchema);
